// Page Design https://pub.rh.net.sa/rowaad/apps

import React from 'react'
import './AppsPage.scss'
import Helmet from 'reactor/components/Helmet'
import BreadcrumbWithImage from '../../../components/BreadcrumbWithImage'
import Summary from '../../../components/Summary'
import AppsFeatures from '../../components/features/AppsFeatures'
import AppsProperties from '../../components/apps/AppsProperties'
import AppsWorks from '../../components/apps/Works'
import BreadcrumbImage from 'assets/images/vector_apps.png'
import SummaryImage from 'assets/images/apps_text_img.png'
import Edit from 'assets/images/edit.png'
import Html from 'assets/images/html.png'
import Lock from 'assets/images/lock.png'
import User from 'assets/images/user.png'
import MobileFeaturesImg from 'assets/images/mobile_features.png'
import { makeStyles } from '@material-ui/core/styles';


// const Goals = [
//     {
//         title: 'ممیزات تطبیقات الاندروید والایفون في رواد',
//         list: [
//             'نستخدم أحدث لغات البرمجة لتنفیذ التطبیقات',
//             'تطبیق اقصى طرق الحمایة للتطبیقات',
//             'توفیر وسائل وخصائص برمجیة تمنح للعمیل الراحة وسهولة',
//             'سهولة التعدیل والإضافة على البرمجیات',
//             'التوافق مع جمیع الهواتف الذكیة',
//             'افضل اسعار لعمل تطبیقات الاندروید والایفون',
//             'تقدیم الاقتراحات للحصول على تطبیق مثالي',
//             'تقدیم الاقتراحات التسویقیة للتطبیق على شبكة الانترنت'
//         ]
//     },
//     {
//         title: 'خصائص التطبیق',
//         list: [
//             `<ul>
//             <li>تصمیم احترافي متوافق مع معاییر ux/ui</li>
//             <li>نعمل في رواد على تصمیم احترافي بأفضل المعاییر والتقنیات التي </br>
//             تسهل الأمر على المستخدمین في الطلب من خلال تطبیق متجرك  </li>
//             <li>تصمیم مخصص للصفحات الداخلیة ( حسابي )</li>
//             <li>تصمیم صفحة المنتجات</li>
//             <li>تصمیم سلاید داخلي في التطبیق</li>
//             <li>تصمیم نافذة منبقة للعروض الخاصة والجدیدة في المتجر.</li>
//             </ul>` ,
//             `<ul>
//             <li>نظام عرض ذكي ومخصص للمنتجات والخصائص</li>
//             <li>نقوم بتصمیم برمجي للتطبیق بحیث یقوم بعرض المنتجات ونظام
//             الطلب والشحن بكل سهولة من خلال التطبیق على هیئة خطوات سهلة
//             وبسیطة</li>
//             </ul>` ,
//             `<ul>
//             <li>توافق التطبیق مع كلا من :</li>
//             <li>دعم جمیع اجهزة الجوال</li>
//             <li>تصمیم مخصص للصفحات الداخلیة ( حسابي )</li>
//             </ul>` ,
//             `<ul>
//             <li>التنبيهات</li>
//             <li>نظام التنبیهات یعرض جدید العروض الجدیدة للمنتجات في تطبیق الجوال</li>
//             </ul>`,
//             `<ul>
//             <li>دعم بوابة الدفع المختلفة</li>
//             <li>تعدد طرق الدفع من خلال تطبیق الجوال</li>
//             </ul>`
//         ]
//     },
// ]

const features = [
    {
        title: 'خصائص برمجية تمنح العميل الراحة والسهولة',
        img: Html,
    },
    {
        title: 'نستخدم أحدث لغات البرمجة لتنفيذ التطبيق',
        img: Lock,
    },
    {
        title: 'سهولة التعامل مع لوحة تحكم التطبيق',
        img: User,
    },
    {
        title: 'عرض مميز، وتصميم يتوافق مع معايير UI & UX',
        img: Edit
    },
    {
        title: 'إمكانية الربط مع شركات الشحن وبوابات الدفع',
        img: User,
    },
    {
        title: 'توفير طرق للحماية والأمان للتطبيقات',
        img: Edit
    },
    {
        title: 'الدعم الفني لمساعدتك في معالجة المشاكل التقنية',
        img: Edit
    },
    {
        title: 'إمكانية تصميم تطبيقات بأفكار مختلفة',
        img: User,
    },
];


const appsproperties = [
    {
        title: 'نظام عرض مميز',
        content: [
            ' قدم خدماتك ومنتجاتك بسهولة من خلال خصائص برمجية</br> تجعل التفاعل مع التطبيق أمرًا سلسًا وممتعًا.'
        ]
    },
    {
        title: 'تصميم يتوافق مع معايير UI/UX',
        content: [
            ' تجربة مستخدم لا تُضاهى مع تصميم يعتني بأدق التفاصيل ويتسق مع معايير</br> التصميم الحديثة لتوفير تجربة فريدة وسهلة للمستخدم.',
        ]
    },
    {
        title: 'الدفع الإلكتروني',
        content: [
            ' سهل على عملائك عمليات  الطلب والشراء من خلال بوابات دفع </br>إلكترونية متعددة، مما يوفر لهم تجربة دفع سلسة وآمنة.'
        ]
    },
    {
        title: 'الشحن والتوصيل',
        content: [
            ' نقوم بربط تطبيقك بشركات الشحن الرائدة لتوسيع نطاق </br> خدماتك والتوصيل للعملاء في جميع أنحاء العالم.'
        ]
    },
    {
        title: 'التنبيهات',
        content: [
            'احتفظ بعملائك مطلعين على كل جديد من خلال تنبيهات</br> فورية حول العروض والخدمات الحصرية التي تقدمها.'
        ]
    },
    {
        title: 'تحكم كامل',
        content: [
            'يمكنك إدارة جميع أقسام التطبيق بشكل كامل من إضافة صفحات </br>أو منتجات وخدمات جديدة أو حذفها، لتشكل تجربة مستخدم مثالية. '
        ]
    },
    {
        title: 'دعم فني ',
        content: [
            'نقوم بتحليل وحل جميع المشاكل التقنية التي تظهر بتطبيقك،</br> لتوفير تجربة مستخدم عالية الجودة بدون أي مشاكل.'
        ]
    },
    {
        title: 'الأمان والحماية',
        content: [
            'نقدم أفضل مستويات الحماية لتطبيقك، مع التركيز على حفظ البيانات </br> الشخصية وبيانات الدفع للعملاء، وذلك لتقديم بيئة آمنة وموثوقة.'
        ]
    },
]

export default function AppsPage() {

    const color = '#24CA64'

    const useStyles = makeStyles({
        root: {
            // backgroundColor: color,
            overflowX: 'hidden',
          '& header': {
              backgroundColor: color,
          }
        }
    });

    const classes = useStyles();

    return (
        <>
            <Helmet
                bodyClass={`apps ${classes.root}`}
                title="تصميم تطبيقات الجوال | رواد لخدمات الويب خبرة أكثر من 12 عام "
                description="اطلب الآن خدمة تصميم تطبيقات الجوال وامتلك تطبيقك بإصدارات مختلفة، هوية مميزة، مزايا عديدة من شركة رواد التي قامت بالتعامل مع +10 آلاف عميل حول المملكة"
            />

            <BreadcrumbWithImage
                text="تصميم تطبيقات الجوال"
                subtext="كن الأقرب لعملائك على هواتفهم"
                img={BreadcrumbImage}
                backgroundColor={color}
            />
            <div className="top__content">
                <Summary
                    title="متى تختار خدمة تصميم تطبيقات الجوال ؟"
                    subtitle=" لتحقيق زيادة في مبيعات منتجاتك أو خدماتك، نصمم تطبيقات جوال بخبرة تفوق 12 عام لتجمع بين الجاذبية والتقنيات المبتكرة الأحدث بعالم التطبيقات والتي تُمكنك من التفاعل المباشر والفعال مع عملائك من أجل عمليات طلب وشراء أكثر."
                    background="#fff"
                    color="#000"
                    image={SummaryImage}
                />
            </div>

            <AppsFeatures object={features} featureImg={MobileFeaturesImg}/>
            <AppsProperties object={appsproperties} />
            {/* <RequestApp/> */}
            <AppsWorks/>
        </>
    )
}